/** state.js
* アプリケーションの状態を保持するオブジェクト
* UIの状態や，送受信する情報のバッファのような使い方をする。
*/

export default {
  headerHeight: 50,   // メニューヘッダの高さ
  rulerWidth: 70,     // 時刻表メモリの幅
  tbHeaderHeight: 50, // 表のヘッダの高さ
  mobileWidthMagnification: 1.5,  // スマホ版のテーブルの幅の倍率
  mobileHeightMagnification: 1, // スマホ版のテーブルの高さの倍率
  rowHeight: 50,      // 行の高さ
  columnWidth: 100,   // 列の幅
  classrooms: [       // 表示と識別に使う教室名
    {name: '3-1', id: 0},
    {name: '3-2', id: 1},
    {name: '5-1', id: 2},
    {name: '5-2', id: 3},
    {name: '5-3', id: 4},
    {name: '4-3', id: 5},
    {name: '4-4', id: 6},
    {name: '4-5', id: 7},
    {name: '4-6', id: 8},
    {name: '4-7', id: 9},
    {name: '4-8', id: 10},
    {name: '4-1(オンライン)', id: 11},
    {name: '4-2(オンライン)', id: 12},
    {name: '面談1', id: 13},
    {name: '面談2', id: 14}
  ],
  timeScaleTicks: [   // 表に使う時刻の一覧
    '10:00',
    '10:30',
    '11:00',
    '11:30',
    '12:00',
    '12:30',
    '13:00',
    '13:30',
    '14:00',
    '14:30',
    '15:00',
    '15:30',
    '16:00',
    '16:30',
    '17:00',
    '17:30',
    '18:00',
    '18:30',
    '19:00',
    '19:30',
    '20:00',
    '20:30',
    '21:00',
    '21:30',
    '22:00',
    '22:30',
    '23:00'
  ],
  timeDivMin: 10, // タイムライン上の操作に使用する細かい分割（分単位）
  previewBox: { // 表のドラッグをした時に現れる予約前のボックス
    start: '10:00',
    end: '10:00',
    classroom: '',
    style: {
      top: 0,
      left: 0,
      height: 0,
      bottom: 0
    },
    isPopupShown: false
  },
  reservationbox: {
    isPopupShown: false
  },
  recurrentRule: '', // 繰り返し予約のルール
  editingState: {
    id: 0,
    start: '10:00',
    end: '10:00',
    classroom: '',
    recurrence_id: 0,
    message: '',
    hasTest: false,
    reservationType: '通常',
    teacher: 0,
    student: 0,
    isRecurrent: false,
    style: {
      top: 0,
      left: 0,
      height: 0
    },
    isPopupShown: false
  },
  rescherdulingState: {
    id: 0,
    date: null,
    start: '10:00',
    end: '10:00',
    classroom: '',
    recurrence_id: 0,
    message: '',
    hasTest: false,
    reservationType: '通常',
    teacher: 0,
    student: 0,
    isRecurrent: false,
    isPopupShown: false
  },
  informationPopup: {
    reservation: {}
  },
  isInfoPopupShown: false, // 予約情報ポップアップの表示状態
  curDate: new Date(), // 表示・編集中の日付
  isLoggedIn: !!localStorage.getItem('token'),  // ログイン状態（トークンの有無)
  pending: false,    // ログイン処理中という状態
  reservations: [], // 予約オブジェクトのリスト。
  lectureInfo: [], // 講義情報
  userInfo: {},    // ユーザーの情報(type, name など)
  userLectures: [], // ユーザー個別の講義情報
  userlist: [], // ユーザー一覧，管理者用
  spinning: false, // スピナーの表示状態
  attendance: [],  // 当日のユーザの来塾状況
  reschedulingInfo: null, // 授業振替情報
  reschedulingHash: null, // 授業振替のハッシュ値
  modal: {
    trigger: false,
    text: 'テスト'
  },
  showOnline: false // オンライン教室表示モードか
}



// WEBPACK FOOTER //
// ./src/vuex/state.js